export const SET_STATES = 'setStates'
